import React from "react";
import NavItem from "../NavItem/NavItem";
import classes from "./NavList.module.css";
import { navItemsData } from "../../../routings";

const NavList: React.FC = () => {
    const navItems: Array<React.ReactNode> = [];

    for (let key in navItemsData) {
        navItems.push(
            <NavItem key={key} path={navItemsData[key].path}>
                {navItemsData[key].title}
            </NavItem>
        );
    }

    return <ul className={classes.NavList}>{navItems}</ul>;
};

export default NavList;
